const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let productIds = urlParams.get('products');
let quantities = urlParams.get('quantities');

if (productIds && quantities) {
  productIds = productIds.split(',')
  quantities = quantities.split(',')

  const items = []

  productIds.forEach((value, key) => {
    items.push({
       id: value,
       quantity: quantities[key]
    })
  })
  
  const payload = {
    items
  }

  jQuery.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: payload,
        success: () => {
          window.location.href = '/cart/checkout'
        }
      });
    },
    error: function(XMLHttpRequest, textStatus) {
      /* error code */
    }
  });
}